<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">提现已提交</div>
      <div class="sub-title">提现审核处理中，工作日24小时内完成</div>
      <div class="btn-middle" @click='hide'>返回</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 187px;
    padding: 30px 0;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .btn-middle {
      margin: 0 auto;
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  export default {
    components: {
      Dialog
    },
    mounted () {
      $bus.$on('confirm', () => {
        this.show()
      })
      $bus.$on('cancle', () => {
        this.hide()
      })
    },
    destroyed () {
      $bus.$off('confirm')
    },
    methods: {
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      }
    }
  }
</script>
